<template lang="pug">
  div.wechat-login
    div.img
      img(:src="qrCodeUrl", v-if="qrCodeUrl")
      span(v-else, @click.prevent="getQrcodeUrl") 二维码已过期，请刷新
        button.fa.fa-refresh
    div.tip 打开微信扫一扫，经服务号验证后登录/注册
</template>

<script>
import client from '../server/server'
export default {
  name: 'WechatLogin',
  data () {
    return {
      qrCodeUrl: '',
      scene: '',
      pollHandler: ''
    }
  },
  // created () {
  //   this.getQrcodeUrl()
  // },
  // destroyed () {
  //   // console.log('stop poll')
  //   clearTimeout(this.pollHandler)
  // },
  activated () {
    this.getQrcodeUrl()
  },
  deactivated () {
    clearTimeout(this.pollHandler)
  },
  methods: {
    getQrcodeUrl () {
      client.getWechatQrcodeLogin()
        .then(res => {
          if (res.success) {
            this.qrCodeUrl = res.data.qrcodeUrl
            this.scene = res.data.scene
            this.pollCheck()
            setTimeout(() => {
              this.qrCodeUrl = ''
              this.scene = ''
            }, 60 * 1000)
          }
        })
    },
    pollCheck () {
      this.$store.dispatch('UserWechatLoginPoll', this.scene)
        .then(res => {
          // console.log(res.success)
          if (res.success) {
            // 如果已经登陆， 则停止轮询
            clearTimeout(this.pollHandler)
            // console.log(res.data.check)
            if (res.data.check === 0) {
              // 注册
              console.log('go to register')
              // 跳转到注册页面
              let data = {
                data: res.data.data,
                nickname: res.data.info.nickname,
                headimgurl: res.data.info.headimgurl
              }
              this.$emit('updateData', data)
              this.$emit('toComponent', 'register', true)
              // let data = Object.assign(res.data.info, {
              //   data: res.data.data
              // })
              // this.$store.commit(GET_WECHAT_REGISTER_PROFILE, data)
              // this.$router.replace({
              //   name: 'Register'
              // })
            }
            if (res.data.check === 1) {
              // 登陆
              console.log('go to index')
              this.$router.replace({
                name: 'EventIndex'
              })
            }
          } else {
            if (this.scene) {
              this.pollHandler = setTimeout(() => {
                this.pollCheck()
              }, 2000)
            }
          }
        })
        .catch(e => {
          console.log('error', e)
          if (this.scene) {
            this.pollHandler = setTimeout(() => {
              this.pollCheck()
            }, 2000)
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .wechat-login{
    text-align: center;
    .img {
      width: 180px;
      height: 180px;
      margin: 0 auto 15px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      img{
        max-width: 100%;
      }
    }
    span:hover{
      cursor: pointer;
    }
    span button{
      margin-left: 1em;
      background: transparent;
      border:none;
    }
    .tip{
      margin-bottom: 60px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/EventIndex/WechatLogin.vue